const bookDemoActionTypes = {
  BOOKDEMO_REQUEST: 'BOOKDEMO_REQUEST',
  BOOKDEMO_SUCCESS: 'BOOKDEMO_SUCCESS',
  BOOKDEMO_FAILURE: 'BOOKDEMO_FAILURE',
  REMOVE_BOOKDEMO_POPUP: 'REMOVE_BOOKDEMO_POPUP',
};

export default bookDemoActionTypes;
